import { createFileRoute } from "@tanstack/react-router";

import { AuditLogPage } from "../../features/audit/audit-log-page";
import { auditSearch } from "../../features/audit/audit-search";

export const Route = createFileRoute("/_app/audit-logs")({
  validateSearch: auditSearch,
  component: AuditLogsRoute,
});

function AuditLogsRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return <AuditLogPage search={search} onSearch={(next) => void navigate({ search: next })} />;
}
